import { Component, EventEmitter, Output } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Output() languageChanged = new EventEmitter<string>();

  selectedLanguage: string = 'hu';

  constructor(private auth: AuthService, private router: Router) {}

  onLanguageChange(lang: string) {
    this.languageChanged.emit(lang);
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

}
